<template>
  <div class="container">
    <div class="top-bg">
      <div class="navi">
          <a @click="isLeaving=true">
            <span class="icon-arrow-left"></span>
          </a>
      </div>
      <div class="title">已选择现金支付</div>
    </div>
    <img class="hero-pic" src="../../assets/img/order/pay-cash.svg">
    <div class="text">
      请联系我们服务人员<br>收取您现金 <span class="color-orange">{{$route.query.amount| numeral('$0,0.00')}}</span>
    </div>
    <div class="btn-box">
      <a class="btn active">我已支付完毕</a>
    </div>
    <div class="js_dialog" v-show="isLeaving">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">确定要返回吗</strong></div>
            <div class="weui-dialog__bd">如需修改支付方式，可在订单页重新选择，并请告知服务人员</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="isLeaving=false">留在本页</a>
                <div  class="weui-dialog__btn weui-dialog__btn_daojia" @click="goback()">返回订单页</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'storage',
  data () {
    return {
      isLeaving:false
    }
  },
  methods: {
    goback(){
      this.$router.push("/order-detail?id="+ this.$route.query.id);
    },
  },
  components: {
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.navi{
  color:#fff;
}
.top-bg{
  background-image: url('/static/img/order/payment-bg.svg');
  background-repeat: no-repeat;
  width:100%;
  height:120px;
  background-position: center center;
  background-size: cover;
  position:absolute;
  top:0;
  padding-top:15px;
}
.weui-cells__title{
    font-size: 22pt;
    text-align: center;
    padding: 0 0 2vh 0;
    font-weight: bold;
}
.title{
  color:#fff;
}
.hero-pic{
  padding:0 30vw;
  text-align:center;
  margin-top:140px;
  width:100vw;
  box-sizing:border-box;
  color:#999;
  a{
    color:#fe9567;
  }
}
.text{
  text-align:center;
  font-size:1.2em;
}
.desc{
  color:#888;
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/pay-cash.vue